module.exports = __webpack_public_path__ + "static/img/IE.cebc0e61.png";